import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import * as actions from '../actions/'
import Toasts, { Props } from '../components/Toasts'
import { GUID } from '../guids'
import { Model } from '../types/types'

type ContainerDispatchProps = Pick<Props, 'removeToast'>

type ContainerStateProps = Pick<Props, 'toasts'>

export function mapStateToProps({ toasts }: Model): ContainerStateProps {
  return { toasts: toasts.slice(0, 10) }
}

export function mapDispatchToProps(
  dispatch: Dispatch<actions.RootAction>,
): ContainerDispatchProps {
  return {
    removeToast: (id: GUID): ReturnType<Props['removeToast']> => (): void => {
      dispatch(actions.removeToast(id))
    },
  }
}

function mergeProps(
  stateProps: ContainerStateProps,
  dispatchProps: ContainerDispatchProps,
  ownProps: {}, // Is this the correct type???
): ContainerStateProps & ContainerDispatchProps {
  return { ...ownProps, ...stateProps, ...dispatchProps }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Toasts)
